export function formatOrdinalActivityDate(dateString: string | undefined): string {
  if (!dateString) return "—";
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return "—";

  const day = date.getDate();
  const ordinalSuffix = (d: number) => {
    switch (d) {
      case 1:
      case 21:
      case 31:
        return "st";
      case 2:
      case 22:
        return "nd";
      case 3:
      case 23:
        return "rd";
      default:
        return "th";
    }
  };

  return `${date.toLocaleString("default", {
    month: "short",
  })} ${day}${ordinalSuffix(day)}, ${date.getFullYear()} | ${date.toLocaleString(
    "default",
    {
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    }
  )}`;
}
